import React, { useRef, useState } from 'react';
import './QuestionsPage.css';
import Footer from '../Footer';
import plusIcon from "./assets/svg/plus.svg";
import minusIcon from "./assets/svg/minus.svg";

const data = {
  'A dadogásról általában': [
    {
      question: 'Mi a dadogás?',
      answer: 'A dadogás egy beszédzavar, amelyre jellemző a szavak, szótagok vagy hangok ismétlése, megnyújtása, illetve a beszéd elakadása. Nem egyszerűen "idegesség" vagy rossz szokás – neurológiai alapja van, és az érintett nem tud akaratlagosan megállítani.'
    },
    {
      question: 'Miért dadognak az emberek?',
      answer: 'A dadogás pontos oka még nem teljesen ismert, de bizonyított, hogy neurológiai tényezők játszanak benne szerepet: a dadogó emberek más agyi idegpályákat használnak a beszédhez. Genetikai hajlam is szerepet játszik – az érintettek kb. 65%-ánál van más érintett a családban. A pszichoszociális tényezők (stressz, fáradtság, a partner személye) befolyásolják a dadogás aktuális intenzitását, de nem okozzák azt.'
    },
    {
      question: 'Elmúlik a dadogás?',
      answer: 'A gyermekek egy részénél (kb. 80%) a dadogás természetes módon elmúlik óvodás- vagy kisiskoláskorban. Ha azonban kb. 7 éves kor után is fennáll, a legjobb tudásunk szerint már nem múlik el magától – de tünetmentessé válhat megfelelő terápiával és önsegítő munkával. Felnőttként is elérhető jelentős javulás.'
    },
    {
      question: 'Befolyásolja-e az intelligenciát vagy a mentális egészséget a dadogás?',
      answer: 'Nem. A dadogás semmiféle összefüggésben nincs az intelligenciával. Az érintetteknek pontosan ugyanolyan gondolataik, ötleteik és képességeik vannak, mint bárki másnak – csupán a beszéd folyamatossága különböző. Ugyanakkor a dadogással kapcsolatos negatív tapasztalatok (pl. csúfolás, megszakítás) hatással lehetnek az önbizalomra és a mentális jóllétre.'
    },
    {
      question: 'Mennyire elterjedt a dadogás?',
      answer: 'A világ népességének körülbelül 1%-a dadogással él – ez globálisan mintegy 80 millió embert jelent. Magyarországon ez kb. 100 000 érintett személyt jelent. A dadogás háromszor-négyszer gyakoribb férfiaknál, mint nőknél.'
    },
  ],
  'Tévhitek és igazságok': [
    {
      question: 'Igaz-e, hogy a dadogók azért dadognak, mert idegesek?',
      answer: 'Ez az egyik legelterjedtebb tévhit. A valóság épp fordítva áll: a dadogók azért lehetnek idegesek, mert dadognak – és nem azért dadognak, mert idegesek. A "csak nyugodj meg" típusú tanácsok általában nem segítenek, sőt, sokszor rontanak a helyzeten, mert a figyelmet a dadogásra irányítják.'
    },
    {
      question: 'Tudatosan kontrollálható-e a dadogás?',
      answer: 'Részben igen – bizonyos technikákkal (pl. lassabb tempó, tudatos légzés) csökkenthető az epizódok gyakorisága és intenzitása. Azonban a dadogás nem egyszerűen "akarat kérdése", és senki nem dadogna szándékosan. Érdemes kerülni az olyan megjegyzéseket, mint "ha akarnád, nem dadognál".'
    },
    {
      question: 'Lehet-e valaki sikeres dadogással?',
      answer: 'Természetesen. Számos ismert személyiség dadogással élt vagy él: Winston Churchill, Joe Biden, Ed Sheeran, Samuel L. Jackson. A dadogás nem akadályozza meg az érintetteket abban, hogy bármilyen területen kiemelkedőt alkossanak – a legfontosabb az önelfogadás és a kitartás.'
    },
    {
      question: 'Trauma okozza-e a dadogást?',
      answer: 'Nem. A dadogás nem pszichológiai trauma következménye. Egy stresszes esemény súlyosbíthatja a tüneteket, de maga a dadogás neurológiai és genetikai alapokon nyugszik. Ez fontos különbség, mert sokan hibásan azt gondolják, hogy "valami baj van a fejével" az érintettnek.'
    },
  ],
  'Kommunikáció dadogó személlyel': [
    {
      question: 'Mit tegyek, ha valaki dadogva beszél velem?',
      answer: 'A legfontosabb: légy türelmes, és várj, amíg az illető befejezi a mondatát. Ne fejezd be helyette a szavait, ne mondd azt, hogy "tudom, mit akarsz mondani". Tartsd a szemkontaktust természetes módon, és reagálj a mondanivalóra – nem a dadogásra. A türelmes, elfogadó hozzáállás sokat számít.'
    },
    {
      question: 'Megkérdezhetem-e valakitől, hogy dadogós-e?',
      answer: 'Általában igen, ha bizalmas, természetes légkörben kerül rá sor, és nem a zavarát kívánod hangsúlyozni, hanem valóban megérteni szeretnéd a helyzetet. Sok érintett értékeli, ha valaki érdeklődik – de kerüld a nyilvánosan feltett, kínos helyzeteket.'
    },
    {
      question: 'Mit NE mondjak dadogó személynek?',
      answer: 'Kerüld a következőket: "Csak nyugodj meg!", "Lassan, nem kell sietni!", "Tudom, mit akarsz mondani" (majd befejezed helyette), "Miért dadogsz?", "Már megint elakadtál". Ezek a megjegyzések – még ha jó szándékból fakadnak is – kellemetlenek, és a dadogásra irányítják a fókuszt az üzenet helyett.'
    },
    {
      question: 'Hogyan segíthetek dadogó ismerősömnek vagy gyermekemnek?',
      answer: 'A leghatékonyabb segítség az elfogadó, ítélkezésmentes légkör megteremtése. Gyermek esetén ne szakítsd félbe, ne fejezd be a mondatait, és ne mutasd ki a türelmetlenségedet. Felnőtt esetén kérdezd meg tőle közvetlenül, miben segíthetsz. Logopédus felkeresése is hasznos lehet, különösen gyermekeknél.'
    },
  ],
  'Az egyesületről': [
    {
      question: 'Kik alapították a BeszÉLJ Egyesületet?',
      answer: 'A BeszÉLJ Egyesületet 2024 nyarán alapították dadogással és/vagy hadarással élő érintettek. Mi vagyunk az első magyarországi szervezet, amelyet teljes egészében érintettek hoztak létre és működtetnek – ezért pontosan értjük az érintettek és családjaik kihívásait.'
    },
    {
      question: 'Milyen programokat szervez az egyesület?',
      answer: 'Rendszeresen szervezünk személyes és online találkozókat, önsegítő csoportokat, workshopokat és közösségi eseményeket. Célunk, hogy minden érintett megtalálja a saját hangját, és egy támogató közösségre lelhessen – függetlenül attól, hol tart az elfogadás útján.'
    },
    {
      question: 'Hogyan csatlakozhatok az egyesülethez?',
      answer: 'Tagsághoz a "Legyél tagunk" gombra kattintva tudsz regisztrálni – ez ingyenes. Részt vehetsz programjainkon, csatlakozhatsz online csatornáinkhoz, vagy akár önkéntesként is bekapcsolódhatsz a munkánkba. Mindenkit szívesen látunk, érintett és nem érintett egyaránt.'
    },
    {
      question: 'Hogyan támogathatom az egyesület munkáját?',
      answer: 'Többféleképpen is támogathatsz minket: adományozással, önkéntesként, vagy partnerként. Minden segítség – legyen az idő, szaktudás vagy pénzügyi hozzájárulás – közvetlen hatással van arra, hogy hány emberhez jutunk el. A "Támogass minket" oldalon részletes információt találsz.'
    },
  ],
};

function FAQItem({ q, a }) {
  const [open, setOpen] = useState(false);
  const contentRef = useRef();
  const toggle = () => setOpen((prev) => !prev);
  return (
    <div className="faq-item">
      <button className="faq-question" onClick={toggle}>
        {q}
        <span className="icon">
          <img src={open ? minusIcon : plusIcon} alt="" className="icon-img" />
        </span>
      </button>
      <div
        ref={contentRef}
        className="faq-answer-wrapper"
        style={{ height: open ? contentRef.current?.scrollHeight : 0 }}
      >
        <div className="faq-answer">{a}</div>
      </div>
    </div>
  );
}

function QuestionsPage() {
  const sections = useRef({});
  const scrollTo = (key) => {
    const el = sections.current[key];
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <div className="faq-page">
      <section className="faq-header">
        <div className="faq-container">
          <h1>Kérdések és válaszok</h1>
        </div>
      </section>
      <div className="faq-container faq-jump">
        <p className="jump-title">Témák</p>
        <div className="jump-links">
          {Object.keys(data).map((key) => (
            <button key={key} onClick={() => scrollTo(key)}>{key}</button>
          ))}
        </div>
      </div>
      <section className="faq-content faq-container">
        {Object.entries(data).map(([topic, questions]) => (
          <div key={topic} className="faq-topic" ref={(el) => (sections.current[topic] = el)}>
            <h2>{topic}</h2>
            {questions.map((item, index) => (
              <FAQItem key={index} q={item.question} a={item.answer} />
            ))}
          </div>
        ))}
      </section>
      <Footer />
    </div>
  );
}

export default QuestionsPage;